module.exports = __webpack_public_path__ + "static/media/archive.77d78eb7.svg";